import { options } from 'common/components/ContentEditor/options';
import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';

import { IToolbarButtonProps, ToolbarButton } from './ToolbarButton';

interface IProps extends IToolbarButtonProps {
    type: string;
    clear?: string;
}

export const ToolbarMark = ({ type, clear, ...props }: IProps) => {
    const editor = useContentEditor();

    return (
        <ToolbarButton
            active={editor.api.hasMark(type)}
            onMouseDown={(event) => {
                event.preventDefault();

                if (!editor.selection) return;

                if (clear) {
                    editor.tf.removeMarks(clear);
                }

                editor.tf.toggleMark(type);
            }}
            {...props}
        />
    );
};

export const ToolbarSuperscript = (props: IToolbarButtonProps) => (
    <ToolbarMark
        clear={options.superscript.clear}
        type={options.superscript.type}
        {...props}
    />
);
